import React from 'react';

export const Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      role="img"
      aria-label="LibreRank icon"
      {...props}
    >
      <defs>
        <linearGradient
          id="sparkGrad"
          x1="168"
          y1="52"
          x2="214"
          y2="98"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FF8F8D" />
          <stop offset="1" stopColor="#FCCD01" />
        </linearGradient>
      </defs>

      {/* Card-style container */}
      <rect
        x="20"
        y="20"
        width="216"
        height="216"
        rx="48"
        fill="#FFFFFF"
        stroke="#000000"
        strokeWidth="10"
      />

      {/* Rank bars */}
      <g stroke="#000000" strokeWidth="10" strokeLinejoin="round">
        <rect x="58" y="150" width="44" height="58" rx="18" fill="#00DAF4" />
        <rect x="106" y="124" width="44" height="84" rx="18" fill="#CF94FF" />
        <rect x="154" y="92" width="44" height="116" rx="18" fill="#FCCD01" />
      </g>

      {/* Spark / signal */}
      <path
        d="M186 52l6 14 14 6-14 6-6 14-6-14-14-6 14-6 6-14z"
        fill="url(#sparkGrad)"
        stroke="#000000"
        strokeWidth="8"
        strokeLinejoin="round"
      />
    </svg>
  );
};